import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import {
  TuiPrimitiveTextfieldModule,
  TuiTextfieldControllerModule
} from "@taiga-ui/core";
import { TuiInputPhoneModule } from "@taiga-ui/kit";
import { KwikUIInputOtpMultipleModule } from "./input-otp-multiple/input-otp-multiple.module";
import { KwikUIInputOtpComponent } from "./input-otp.component";

@NgModule({
  declarations: [KwikUIInputOtpComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TuiInputPhoneModule,
    TuiPrimitiveTextfieldModule,
    TuiTextfieldControllerModule,
    KwikUIInputOtpMultipleModule
  ],
  exports: [KwikUIInputOtpComponent]
})
export class KwikUIInputOtpModule {}
